import { memo } from 'react'
import { MentorBase } from '../../types/mentor'
import { SuggestedCompanionItem } from './SuggestedCompanionItem'

interface ISuggestedCompanionsProps {
  companions: MentorBase[]
  isMobile?: boolean
}

const SuggestedCompanions: React.FC<ISuggestedCompanionsProps> = memo(
  ({ companions, isMobile }) => {
    const className = isMobile
      ? 'w-full bottom-[100px] px-2 h-full overflow-auto flex flex-col gap-2 pt-2'
      : 'flex flex-col gap-2 overflow-auto max-h-[calc(100vh-300px)] pb-2'

    return (
      <div className={className}>
        {companions.map(companion => (
          <SuggestedCompanionItem
            key={companion.mentorId}
            companion={companion}
          />
        ))}
      </div>
    )
  },
)

export { SuggestedCompanions }
